import { Form, Data, FormField, ModalId, useUIActions, FieldType, option, FieldValue, Option, StaticValue, O } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { Tax } from '../../../state/types'
import { TableName } from "../../../../../tables"
import { useState } from "react"
import { firstItem } from "../../../../../utils/listUtils"
import { useTaxHooks } from "../../../hooks/taxHooks"

type Props = {
    taxItem?: Data
    total?: number
    vatAmount?: number
    editableAmount?: boolean
    taxes: Tax[]
    onSubmit: (data: Data) => void
}

export const TaxItemForm = (props: Props) => {
    const { taxItem, total = 0, vatAmount = 0, editableAmount, taxes, onSubmit } = props
    const createMode = !taxItem
    
    const { calculateTaxAmount } = useTaxHooks()
    
    const findTax = (taxCode?: string) => taxes.find(tax => tax.code === taxCode)
    
    const defaultTaxCode = (taxItem?.taxCode || firstItem(taxes)?.code) as O<string>
    const defaultTax = findTax(defaultTaxCode)
    const defaultTaxYield = defaultTax?.yield
    const defaultAmount = (taxItem?.amount || defaultTax && calculateTaxAmount(defaultTax, total, vatAmount)) as O<number>
    const [taxYield, setTaxYield] = useState<O<number>>(defaultTaxYield)
    const [amount, setAmount] = useState<O<number>>(defaultAmount)
    
    const { toggleModal } = useUIActions()

    const taxOptions = taxes.map(tax => option(tax.code, tax.name))
    
    const renderOption = async (
        option: Option,
        onClick?: (e: React.MouseEvent<HTMLElement>) => void
    ) => {
        const tax = define(findTax(option.value))
        return (
            <div onClick={onClick}>
                {tax.name} ({tax.yield}%)
            </div>
        )
    }

    const onChangeTaxCode = (value?: FieldValue) => {
        const tax = findTax(value as O<string>)
        if (tax) {
            setTaxYield(tax?.yield)
            setAmount(calculateTaxAmount(tax, total, vatAmount))
        }
    }

    const onChangeAmount = (value?: FieldValue) => {
        setAmount(value as O<number>)
    }

    const renderAmount = !editableAmount ? (() => <StaticValue type={FieldType.PRICE} value={amount} />) : undefined

    const fields: FormField[] = [
        {
            name: 'taxCode',
            type: FieldType.TABLE,
            table: TableName.TAXES,
            label: 'Impuesto',
            defaultValue: defaultTaxCode,
            options: taxOptions,
            placeholder: 'Seleccionar impuesto',
            renderOption,
            onChange: onChangeTaxCode
        },
        {
            name: 'taxYield',
            type: FieldType.PERCENTAGE,
            value: taxYield,
            label: '%',
            disabled: true
        },
        {
            name: 'amount',
            type: FieldType.PRICE,
            label: 'Monto',
            value: amount,
            onChange: onChangeAmount,
            render: renderAmount
        }
    ]
    
    const handleSubmit = (data: Data) => {
        onSubmit({
            ...data,
            taxYield: define(taxYield),
            amount
        })
        toggleModal(ModalId.TAX_ITEM_FORM)
    }

    const handleCancel = () => toggleModal(ModalId.TAX_ITEM_FORM)

    return (
        <Form
            formId="tax-item-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
